import actionTypes from './actionTypes';
import DEFAULT_STATE from './state';

export function reducer(state = DEFAULT_STATE, action) {
  return action.type === actionTypes.SET_DEFAULT_CSS_LIBRARY
    ? {
        ...state,
        defaultCssLibrary: action.defaultCssLibrary,
      }
    : state;
}

export default reducer;
